function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.symbol.async-iterator.js";
import "core-js/modules/es.symbol.to-string-tag.js";
import "core-js/modules/es.json.to-string-tag.js";
import "core-js/modules/es.math.to-string-tag.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.slice.js";
import { normalizeArg } from "./functions";
import Weiwudi from "weiwudi";
import { NowMap } from "./source/nowmap";
import { TmsMap } from "./source/tmsmap";
import { MapboxMap } from "./source/mapboxmap";
import { GoogleMap } from "./source/googlemap";
import { HistMap_tin } from "./source/histmap_tin";
import "whatwg-fetch";
import osm from "../parts/osm.jpg";
import gsi from "../parts/gsi.jpg";
import gsi_ortho from "../parts/gsi_ortho.jpg";
var baseDict = {
  osm: {
    mapID: "osm",
    title: {
      ja: "オープンストリートマップ",
      en: "OpenStreetMap"
    },
    label: {
      ja: "OSM(現在)",
      en: "OSM(Now)"
    },
    attr: "©︎ OpenStreetMap contributors",
    maptype: "base",
    thumbnail: osm,
    urls: ["https://a.tile.openstreetmap.org/{z}/{x}/{y}.png", "https://b.tile.openstreetmap.org/{z}/{x}/{y}.png", "https://c.tile.openstreetmap.org/{z}/{x}/{y}.png"]
  },
  gsi: {
    mapID: "gsi",
    title: {
      ja: "地理院地図",
      en: "Geospatial Information Authority of Japan Map"
    },
    label: {
      ja: "地理院地図",
      en: "GSI Map"
    },
    attr: {
      ja: "国土地理院",
      en: "The Geospatial Information Authority of Japan"
    },
    maptype: "base",
    url: "https://cyberjapandata.gsi.go.jp/xyz/std/{z}/{x}/{y}.png",
    maxZoom: 18,
    thumbnail: gsi
  },
  gsi_ortho: {
    mapID: "gsi_ortho",
    title: {
      ja: "地理院地図オルソ航空写真",
      en: "Geospatial Information Authority of Japan Ortho aerial photo"
    },
    label: {
      ja: "地理院オルソ",
      en: "GSI Ortho"
    },
    attr: {
      ja: "国土地理院",
      en: "The Geospatial Information Authority of Japan"
    },
    maptype: "base",
    url: "https://cyberjapandata.gsi.go.jp/xyz/ort/{z}/{x}/{y}.jpg",
    maxZoom: 18,
    thumbnail: gsi_ortho
  }
};
var checkMapTypeIsWMTS = function checkMapTypeIsWMTS(maptype) {
  return (maptype || '').match(/^(?:base|overlay|google(?:_(?:roadmap|satellite|hybrid|terrain))?|mapbox|osm)$/);
};
export function mapSourceFactory(_x, _x2) {
  return _mapSourceFactory.apply(this, arguments);
}
function _mapSourceFactory() {
  _mapSourceFactory = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(options, commonOptions) {
    var targetSrc, obj;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (typeof options === "string") {
            options = baseDict[options];
          }
          options = normalizeArg(Object.assign(options, commonOptions));
          options.label = options.label || options.year;
          if (!checkMapTypeIsWMTS(options.maptype)) {
            _context2.next = 25;
            break;
          }
          targetSrc = options.maptype === "base" ? NowMap : options.maptype === "overlay" ? TmsMap : options.maptype === "mapbox" ? MapboxMap : GoogleMap;
          if (!targetSrc.isBasemap()) {
            if (!options.homePosition) options.homePosition = options.homePos;
            if (!options.mercZoom) options.mercZoom = options.defZoom;
          } else {
            options.homePosition = options.homePos;
            options.mercZoom = options.defZoom;
          }
          delete options.homePos;
          delete options.defZoom;
          if (options.zoomRestriction) {
            options.maxZoom = options.maxZoom || options.mercMaxZoom;
            options.minZoom = options.minZoom || options.mercMinZoom;
          }
          options.zoomRestriction = options.mercMaxZoom = options.mercMinZoom = undefined;
          if (options.translator) {
            options.url = options.translator(options.url);
          }
          if (!options.imageExtension) options.imageExtension = "jpg";
          if (options.mapID && !options.url && !options.urls) {
            options.url = options.tms ? "tiles/".concat(options.mapID, "/{z}/{x}/{-y}.").concat(options.imageExtension) : "tiles/".concat(options.mapID, "/{z}/{x}/{y}.").concat(options.imageExtension);
          }
          _context2.next = 15;
          return registerMapToSW(options);
        case 15:
          options.weiwudi = _context2.sent;
          if (options.weiwudi) {
            options.url = options.weiwudi.url;
            delete options.urls;
          }
          _context2.next = 19;
          return targetSrc.createAsync(options);
        case 19:
          obj = _context2.sent;
          _context2.next = 22;
          return obj.initialWait;
        case 22:
          return _context2.abrupt("return", obj);
        case 25:
          if (!options.noload) {
            _context2.next = 28;
            break;
          }
          options.mercMaxZoom = options.mercMinZoom = undefined;
          return _context2.abrupt("return", new HistMap_tin(options));
        case 28:
          return _context2.abrupt("return", new Promise(function (resolve, reject) {
            var url = options.settingFile || "maps/".concat(options.mapID, ".json");
            var xhr = new XMLHttpRequest();
            xhr.open("GET", url, true);
            xhr.responseType = "json";
            xhr.onload = /*#__PURE__*/function () {
              var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_e) {
                var resp, _targetSrc, _obj, _obj2;
                return _regeneratorRuntime().wrap(function _callee$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      if (!(this.status === 200 || this.status === 0)) {
                        _context.next = 75;
                        break;
                      }
                      _context.prev = 1;
                      resp = this.response;
                      if (_typeof(resp) != "object") resp = JSON.parse(resp);
                      options = normalizeArg(Object.assign(resp, options));
                      options.label = options.label || resp.year;
                      if (options.translator) {
                        options.url = options.translator(options.url);
                      }
                      if (!options.maptype) options.maptype = "maplat";
                      if (!checkMapTypeIsWMTS(options.maptype)) {
                        _context.next = 40;
                        break;
                      }
                      _targetSrc = options.maptype === "base" ? NowMap : options.maptype === "overlay" ? TmsMap : options.maptype === "mapbox" ? MapboxMap : GoogleMap;
                      if (!_targetSrc.isBasemap()) {
                        if (!options.homePosition) options.homePosition = options.homePos;
                        if (!options.mercZoom) options.mercZoom = options.defZoom;
                      } else {
                        options.homePosition = options.homePos;
                        options.mercZoom = options.defZoom;
                      }
                      delete options.homePos;
                      delete options.defZoom;
                      if (options.zoomRestriction) {
                        options.maxZoom = options.maxZoom || options.mercMaxZoom;
                        options.minZoom = options.minZoom || options.mercMinZoom;
                      }
                      options.zoomRestriction = options.mercMaxZoom = options.mercMinZoom = undefined;
                      _context.prev = 15;
                      if (!options.imageExtension) options.imageExtension = "jpg";
                      if (options.mapID && !options.url && !options.urls) {
                        options.url = options.tms ? "tiles/".concat(options.mapID, "/{z}/{x}/{-y}.").concat(options.imageExtension) : "tiles/".concat(options.mapID, "/{z}/{x}/{y}.").concat(options.imageExtension);
                      }
                      _context.next = 20;
                      return registerMapToSW(options);
                    case 20:
                      options.weiwudi = _context.sent;
                      if (options.weiwudi) {
                        options.url = options.weiwudi.url;
                        delete options.urls;
                      }
                      _context.next = 24;
                      return _targetSrc.createAsync(options);
                    case 24:
                      _obj = _context.sent;
                      _context.prev = 25;
                      _context.next = 28;
                      return _obj.initialWait;
                    case 28:
                      resolve(_obj);
                      _context.next = 34;
                      break;
                    case 31:
                      _context.prev = 31;
                      _context.t0 = _context["catch"](25);
                      resolve(_obj);
                    case 34:
                      _context.next = 39;
                      break;
                    case 36:
                      _context.prev = 36;
                      _context.t1 = _context["catch"](15);
                      reject(_context.t1);
                    case 39:
                      return _context.abrupt("return");
                    case 40:
                      _context.prev = 40;
                      delete options.homePos;
                      delete options.defZoom;
                      if (!options.imageExtension) options.imageExtension = "jpg";
                      if (options.mapID && !options.url && !options.urls) {
                        options.url = "tiles/".concat(options.mapID, "/{z}/{x}/{y}.").concat(options.imageExtension);
                      }
                      options.width = options.width || options.compiled.wh[0];
                      options.height = options.height || options.compiled.wh[1];
                      _context.next = 49;
                      return registerMapToSW(options);
                    case 49:
                      options.weiwudi = _context.sent;
                      if (options.weiwudi) {
                        options.url = options.weiwudi.url;
                        delete options.urls;
                      }
                      _context.next = 53;
                      return HistMap_tin.createAsync(options);
                    case 53:
                      _obj2 = _context.sent;
                      _context.prev = 54;
                      _context.next = 57;
                      return _obj2.initialWait;
                    case 57:
                      _obj2.setupMapParameter(resolve);
                      _context.next = 63;
                      break;
                    case 60:
                      _context.prev = 60;
                      _context.t2 = _context["catch"](54);
                      _obj2.setupMapParameter(resolve);
                    case 63:
                      _context.next = 68;
                      break;
                    case 65:
                      _context.prev = 65;
                      _context.t3 = _context["catch"](40);
                      reject(_context.t3);
                    case 68:
                      _context.next = 73;
                      break;
                    case 70:
                      _context.prev = 70;
                      _context.t4 = _context["catch"](1);
                      reject(_context.t4);
                    case 73:
                      _context.next = 76;
                      break;
                    case 75:
                      reject("Fail to load map json");
                    case 76:
                    case "end":
                      return _context.stop();
                  }
                }, _callee, this, [[1, 70], [15, 36], [25, 31], [40, 65], [54, 60]]);
              }));
              return function (_x4) {
                return _ref.apply(this, arguments);
              };
            }();
            xhr.send();
          }));
        case 29:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _mapSourceFactory.apply(this, arguments);
}
export function registerMapToSW(_x3) {
  return _registerMapToSW.apply(this, arguments);
}
function _registerMapToSW() {
  _registerMapToSW = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(options) {
    var setting, lngLats, minMax, ret;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          setting = {};
          if (!(options.maptype === "mapbox" || options.maptype === "google" || !options.enableCache)) {
            _context3.next = 5;
            break;
          }
          return _context3.abrupt("return");
        case 5:
          if (options.maptype === "base" || options.maptype === "overlay") setting.type = "wmts";else setting.type = "xyz";
        case 6:
          setting.url = options.urls ? options.urls : options.url;
          setting.width = options.width;
          setting.height = options.height;
          setting.maxZoom = options.maxZoom;
          setting.minZoom = options.minZoom;
          lngLats = options.envelopeLngLats;
          if (lngLats) {
            minMax = lngLats.reduce(function (prev, curr) {
              prev[0] = prev[0] > curr[0] ? curr[0] : prev[0];
              prev[1] = prev[1] < curr[0] ? curr[0] : prev[1];
              prev[2] = prev[2] > curr[1] ? curr[1] : prev[2];
              prev[3] = prev[3] < curr[1] ? curr[1] : prev[3];
              return prev;
            }, [Infinity, -Infinity, Infinity, -Infinity]);
            ["minLng", "maxLng", "minLat", "maxLat"].map(function (key, index) {
              setting[key] = minMax[index];
            });
          }
          _context3.prev = 13;
          _context3.next = 16;
          return Weiwudi.registerMap(options.mapID, setting);
        case 16:
          ret = _context3.sent;
          _context3.next = 21;
          break;
        case 19:
          _context3.prev = 19;
          _context3.t0 = _context3["catch"](13);
        case 21:
          return _context3.abrupt("return", ret);
        case 22:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[13, 19]]);
  }));
  return _registerMapToSW.apply(this, arguments);
}